import { render, staticRenderFns } from "./ProductIdCard.vue?vue&type=template&id=def5b7bc&scoped=true&"
import script from "./ProductIdCard.vue?vue&type=script&lang=js&"
export * from "./ProductIdCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductIdCard.vue?vue&type=style&index=0&id=def5b7bc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def5b7bc",
  null
  
)

export default component.exports